import classNames from 'classnames';

export function Divider({ className }) {
  return <div className={classNames('b-light-purple h-1 w-100', className)} />;
}
